import instance from 'configs/requests';
import { SystemTasks } from 'constants/enums';

export const checkAthenaOrderTask = () => {
  // Fire and forget
  instance.post('/clinician/system-tasks', { task: SystemTasks.ATHENA_ORDERS }).catch(() => {});
};
